<script>
  import currentUser from '../stores/auth';
  import supabase from '../db';
  import {Link, navigate} from "svelte-routing";

  let errorMsg = "Please enter correct email";
  let email = "";
  let emailEl;

  let isResetting = false;
  let passwordResetSent = false;

  async function passwordReset() {
    errorMsg = 'Please enter correct email';
    if (emailEl) emailEl.setCustomValidity("");

    if (!emailEl || !emailEl.checkValidity()) return false;

    try {
      isResetting = true;
      let {error: dbError} = await supabase.auth.api.resetPasswordForEmail(email);

      if (dbError) {
        errorMsg = dbError.message;
        if (emailEl) emailEl.setCustomValidity(errorMsg);

        return false;
      }

      passwordResetSent = true;

      isResetting = false;
    } catch {
      errorMsg = "Unknown error has occurred";

      isResetting = false;
    }

    return false;
  }

  function redirectIfNeeded(user) {
    if (user) navigate(`/projects`);
  }

  $: redirectIfNeeded($currentUser)
</script>

<section class="nes-container is-dark is-rounded with-title">
  <h2 class="title">Password reset</h2>
  {#if !passwordResetSent}
    <section class="form">
      <div class="nes-field">
        <label for="email">Email</label>
        <input type="email" id="email" class="nes-input is-dark"
               required bind:this={emailEl} bind:value={email}
        >
        <div class="nes-text is-error">{errorMsg}</div>
      </div>

      <button type="button" class={`nes-btn ${isResetting ? 'is-disabled' : 'is-primary'}`} on:click={passwordReset} class:disabled={isResetting}>Reset
        password
      </button>
      <Link to="/login">Login</Link>
    </section>
  {:else}
    <p>Password reset link has been sent. Check your email box.</p>
  {/if}
</section>

<style>
    .form {
        margin: 0 auto;
        max-width: 30rem;
    }

    .form .nes-field {
        margin-bottom: 1.5rem;
    }

    input[type=email]:valid + .nes-text {
        display: none
    }

    input[type=email]:invalid + .nes-text {
        display: block;
    }

    .is-error {
        margin-top: .5rem;
    }
</style>